import React, { useEffect, useState } from "react";
import { aboveHeader1 } from "../../assets/images";
import axios from "axios";
import PaginatedItemsMobile from "./PaginatedItemsMobile";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";


const Header = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const location = useLocation();
  const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading2, setIsLoading2] = useState(true);

  const toggleSearch = () => {
    setSearchQuery("");
  };

  useEffect(() => {
    getProducts(); 
    getCategories()
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );
      setProducts(response.data.data);
      setIsLoading2(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getCategories = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/categories.php`,
        { withCredentials: false }
      );
      setCategories(response.data.data);
      setIsLoading2(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const isActiveLink = (path) => location.pathname === path;

  const filteredProducts = searchQuery
    ? products.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

     const getLocalizedField = (item, fieldBase) => {
    if (currentLanguage === "en")
      return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === "ru")
      return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  return (
    <>
      <div className="bg-white">
        <div className="hidden md:block md:max-w-container h-[64px] mx-auto">
          <ul className="flex justify-between items-center text-[#0B0B0B] w-[1025px] mx-auto h-[64px]">
            <a
              className={`mr-[40px] ${
                isActiveLink(`/${currentLanguage}/`) ? "text-[#E497BB] " : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/`}
            >
              <li>{t("Ana səhifə")}</li>
            </a>
            <a
              className={`mr-[40px] ${
                isActiveLink(`/${currentLanguage}/about`) ? "text-[#E497BB] " : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/about`}
            >
              <li>{t("Haqqımızda")}</li>
            </a>

         <div className="relative group mr-[40px]">
  <a
    href={`/${currentLanguage}/products`}
    className={`flex items-center gap-1 py-5 ${
      isActiveLink(`/${currentLanguage}/products`)
        ? "text-[#E497BB]"
        : "text-[#0B0B0B]"
    }`}
  >
    <li className="list-none">{t("Məhsullar")}</li>
    <FaChevronDown className="text-[10px] mt-[2px]" />
  </a>

  {/* Dropdown */}
  <div className="absolute top-full left-0 w-48 bg-white border rounded shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-opacity duration-200 z-50">
    {/* <a
      href={`/${currentLanguage}/products?categories=Dodaq Boyaları`}
      className="block px-4 py-2 hover:bg-gray-100 text-sm text-[#0B0B0B]"
    >
      {t("Dodaq Boyaları")}
    </a> 
    <a
      href={`/${currentLanguage}/products?categories=Kipriklər`}
      className="block px-4 py-2 hover:bg-gray-100 text-sm text-[#0B0B0B]"
    >
      {t("Kipriklər")}
    </a>
    <a
      href={`/${currentLanguage}/products?categories=Professional Görünüş`}
      className="block px-4 py-2 hover:bg-gray-100 text-sm text-[#0B0B0B]"
    >
      {t("Professional Görünüş")}
    </a> */}
    {categories.map((item) => (
       <a 
      href={`/${currentLanguage}/products?categories=${item.name}`}
      className="block px-4 py-2 hover:bg-gray-100 text-sm text-[#0B0B0B]"
    >
      {getLocalizedField(item, "name")}
    </a>
    ))} 
  </div>
</div>


            <a
              className={`mr-[40px] ${
                isActiveLink(`/${currentLanguage}/kampaniya`) ? "text-[#E497BB] " : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/kampaniya`}
            >
              <li>{t("Kampaniyalar")}</li>
            </a>
            <a
              className={`mr-[40px] ${
                isActiveLink(`/${currentLanguage}/blogs`)
                  ? "text-[#E497BB] "
                  : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/blogs`}
            >
              <li>{t("Bloq")}</li>
            </a>
            <a
              className={`mr-[40px] ${
                isActiveLink(`/${currentLanguage}/comments`) ? "text-[#E497BB] " : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/comments`}
            >
              <li>{t("Müştəri Rəyləri")}</li>
            </a>

            <a
              className={`mr-[40px] ${ 
                isActiveLink(`/${currentLanguage}/privacy`) ? "text-[#E497BB]" : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/privacy`}
            >
              <li>{t("Məxfilik")}</li>
            </a>

            <a
              className={` ${
                isActiveLink(`/${currentLanguage}/contact`) ? "text-[#E497BB] " : "text-[#0B0B0B]"
              }`}
              href={`/${currentLanguage}/contact`}
            >
              <li>{t("Əlaqə")}</li>
            </a>
          </ul>
        </div>
     <div className="md:hidden max-w-containerSm mx-auto py-3">
<div className="w-full justify-center">
            <div className="relative">
              <button className="absolute top-3 left-4 text-white">
                <img alt="Search" className="h-6 w-6" src={aboveHeader1}></img>
              </button>
              <input
                type="text"
                value={searchQuery} 
                onChange={handleSearchChange}
                placeholder={t("Axtar...")}
                className="rounded-[8px] w-full bg-[#F5F5F5] h-[44px] outline-none focus:ring-0 focus:outline-none px-12 text-firstColor"
              />
              <button
                onClick={toggleSearch}
                className="absolute top-[11px] right-4 text-white"
              ></button>
            </div>
          </div>
     </div>
       {searchQuery && (
             <div className="absolute top-0 left-0 w-full bg-white mt-[140px] md:hidden z-50">
               {isLoading2 ? (
                 <p className="text-black text-center">Loading...</p>
               ) : (
                 <PaginatedItemsMobile itemsPerPage={12} items={filteredProducts} />
               )}
             </div>
           )}
      </div>
    </>
  );
};

export default Header;
